<template>
    <div class="cube-query-renderer">
        <slot
            :loading="loading"
            :error="error"
            :resultSet="resultSet"
            :loadingState="loadingState"
        />
    </div>
</template>

<script>
import { QueryRenderer } from '@cubejs-client/vue';

export default {
    name: 'CubeQueryRenderer',
    extends: QueryRenderer,
    props: {
        query: {
            type: Object,
            required: true
        },
        cubeApi: {
            type: Object,
            required: false
        }
    },
    data() {
        return {
            loading: true,
            error: null,
            resultSet: null
        };
    },
    computed: {
        loadingState() {
            if (this.error) {
                return 'error';
            }
            if (this.loading) {
                return 'loading';
            }
            return 'ready';
        }
    },
    watch: {
        query: {
            handler() {
                this.fetchData();
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        async fetchData() {
            if (!this.query || Object.keys(this.query).length === 0) {
                this.loading = false;
                return;
            }

            this.loading = true;
            this.error = null;

            try {
                const api = this.cubeApi || this.$cubeApi;
                if (!api) {
                    throw new Error('Cube API instance not found');
                }

                const resultSet = await api.load(this.query);
                this.resultSet = resultSet;
                this.loading = false;
            } catch (err) {
                this.error = err;
                this.loading = false;
                this.$emit('error', err);
            }
        }
    }
};
</script>
